const actions = {
    async likePost({state, commit}, postId) {
        return state.socialService.likePost(postId)
            .then(_ => commit("setPostLike", postId))
            .catch(error => {
                commit("setErrors", {"likePostError": error.message});
                return Promise.reject(error);
            });
    },
    async unlikePost({state, commit}, postId) {
        return state.socialService.unlikePost(postId)
            .then(_ => commit("setPostUnlike", postId))
            .catch(error => {
                commit("setErrors", {"unlikePostError": error.message});
                return Promise.reject(error);
            });
    },
    async nextPostComments({state, commit}, postId) {
        return state.socialService.comments(postId)
            .then(({comments, users}) => {
                if (comments.length) commit("addPostComments", {postId, comments});
                if (users.length) commit("setUsers", users);
            })
            .catch(error => {
                commit("setErrors", {"nextPostError": error.message});
                return Promise.reject(error);
            });
    },
    async addComment({state, commit}, {postId, description}) {
        console.log('postId', postId, 'description', description);
        return state.socialService.addComment(postId, description)
            .then(comment => commit("setComment", {postId, comment}))
            .catch(error => {
                commit("setErrors", {"addCommentError": error.message});
                return Promise.reject(error);
            });
    },
    async editComment({state, commit}, {commentId, description, postId}) {
        return state.socialService.editComment(commentId, description, postId)
            .then(comment => commit('updateComment', { postId, comment}))
            .catch(error => {
                commit("setErrors", {"editCommentError": error.message});
                return Promise.reject(error);
            });
    },
    async deleteComment({state, commit}, {postId, commentId}) {
        return state.socialService.deleteComment(commentId, postId)
            .then(_ => commit('deleteComment', {postId, commentId}))
            .catch(error => {
                commit("setErrors", {"deleteCommentError": error.message});
                return Promise.reject(error);
            });
    },
    async reportComment({state, commit}, {commentId, postId, reason, userId}) {
        return state.socialService.reportComment(commentId, reason, postId, userId, state.activeUserId)
            .then(res => console.log('reportComment: ', res))
            .catch(error => {
                commit("setErrors", {"reportCommentError": error.message});
                return Promise.reject(error);
            });
    },
    async reportPost({state, commit}, {postId, reason, userId}) {
        return state.socialService.reportPost(postId, reason, userId, state.activeUserId)
            .then(res => console.log("reportedPost: ", res))
            .catch(error => {
                commit("setErrors", {"reportPostError": error.message});
                return Promise.reject(error);
            });
    },
    async createMultiMediaPost({state, commit}, post) {
        return state.socialService.createMultiMediaPost(post)
            .then(({post, user}) => {
                commit("addPost", post);
                commit("setUsers", [user]);
                return {post, user};
            }).catch(error => {
                commit("setErrors", {"createPostError": error.message});
                return Promise.reject(error);
            });
    },
    async createTextPost({state, commit}, post) {
        return state.socialService.createTextPost(post)
            .then(({post, user}) => {
                commit("addPost", post);
                commit("setUsers", [user]);
                return {post, user};
            }).catch(error => {
                commit("setErrors", {"createPostError": error.message});
                return Promise.reject(error);
            });
    },

    async hashtagDetails({state, commit}, hashtag) {
        return state.socialService.hashtagInfo(hashtag)
            .then(hashtagInfo => hashtagInfo)
            .catch(error => {
                commit("setErrors", {"hashtagInfoError": error.message});
                return Promise.reject(error);
            });
    },

    async nextHashtagPosts({state, commit}, hashtag) {
        return state.socialService.hashtagPosts(hashtag)
            .then(({posts, users}) => {
                if (posts.length) commit("setHashtagPosts", posts);
                if (users.length) commit("setUsers", users);
            }).catch(error => {
                commit("setErrors", {"nextHashtagPostsError": error.message});
                return Promise.reject(error);
            });
    }
};

export default {
    actions
}